<section class="admin_settings">
  <h1>{{ 'new_entries.settings_and_preferences' | translate }}</h1>
  <p>{{ 'new_entries.customize_analysis' | translate }} <a
      href="https://support.inspera.com/hc/en-us/articles/24760211588637-Administrators-Manage-System-Settings"
      target="_blank">{{ 'new_entries.learn_more' | translate }}</a></p>

  <form [formGroup]="admin_settings">

    <!-- Originality Feature Configuration -->
    <h2>{{ 'new_entries.originality_feature_configuration' | translate }}</h2>
    <p class="sub_heading">{{ 'new_entries.these_settings_control_the_configuration' | translate }}</p>

    <!-- Translation Similarity -->
    <section class="single_form_input" *ngIf="institutionSettings?.translationAnalysisPaid">
      <section class="header">
        <h3>
          {{ 'new_entries.translation_similarity' | translate }}
          <button matTooltipClass="new_report_tooltip" matTooltipPosition="above"
            [matTooltip]="'new_entries.translation_similarity_languages' | translate">
            <img src="../../../../assets/report_v2/info.svg" alt="">
          </button>
        </h3>
        <label class="switch">
          <input type="checkbox" [formControl]="translatedLanguageEnabled" />
          <span class="slider round"></span>
        </label>
      </section>
      <section class="body" *ngIf="translatedLanguageEnabled.value">
        <p>{{ 'new_entries.select_languages' | translate }}</p>
        <section class="language-selection">
          <mat-form-field>
            <mat-select [formControl]="selectedTranslatedLanguages" multiple>
              <mat-option *ngFor="let  language of languages" [value]="language.value"
                [disabled]="selectedTranslatedLanguages.value.length >= 3 && !isSelected(language.value)">
                {{ language.text }}
              </mat-option>
            </mat-select>
            <mat-hint *ngIf="selectedTranslatedLanguages.value.length > 0">
              {{ selectedTranslatedLanguages.value.length }}/3 {{ 'new_entries.selected' | translate }}
            </mat-hint>
          </mat-form-field>
        </section>
        <section class="invalid" *ngIf="selectedTranslatedLanguages.errors?.maxlength">
          You can select up to 3 languages only.
        </section>
      </section>
    </section>

    <!-- AI Prediction -->
    <section class="single_form_input" *ngIf="institutionSettings?.aiDetectionPaid">
      <section class="header">
        <h3>
          {{ 'general.enable_ai_prediction' | translate }}:
          <button matTooltipClass="new_report_tooltip" matTooltipPosition="above"
            [matTooltip]="'new_entries.ai_prediction_capability' | translate">
            <img src="../../../../assets/report_v2/info.svg" alt="">
          </button>
        </h3>
        <label class="switch">
          <input type="checkbox" formControlName="aiDetection" />
          <span class="slider round"></span>
        </label>
      </section>
    </section>

    <!-- Metadata Analysis -->
    <section class="single_form_input">
      <section class="header">
        <h3>
          {{ 'new_entries.metadata_analysis' | translate }}
          <button matTooltipClass="new_report_tooltip" matTooltipPosition="above"
            [matTooltip]="'new_entries.metadata_analysis_tooltip' | translate">
            <img src="../../../../assets/report_v2/info.svg" alt="">
          </button>
        </h3>
        <label class="switch">
          <input type="checkbox" formControlName="metadataAnalysis" />
          <span class="slider round"></span>
        </label>
      </section>
    </section>

    <!-- Stylometrics Analysis -->
    <!-- <section class="single_form_input">
      <section class="header">
        <h3>
          {{ 'new_entries.stylometrics_analysis' | translate }}
          <button matTooltipClass="new_report_tooltip" matTooltipPosition="above" [matTooltip]="'new_entries.stylometrics_analysis_tooltip' | translate">
            <img src="../../../../assets/report_v2/info.svg" alt="">
          </button>
        </h3>
        <label class="switch">
          <input type="checkbox" formControlName="stylometricsAnalysis" />
          <span class="slider round"></span>
        </label>
      </section>
    </section> -->

    <!-- Contextual Similarity -->
    <section class="single_form_input">
      <section class="header">
        <h3>
          {{ 'new_entries.contextual_similarity_threshold' | translate }}
          <button matTooltipClass="new_report_tooltip" matTooltipPosition="above"
            [matTooltip]="'new_entries.contextual_similarity_in_report' | translate">
            <img src="../../../../assets/report_v2/info.svg" alt="">
          </button>
        </h3>
        <label class="switch">
          <input type="checkbox" formControlName="contextualSimilarity" />
          <span class="slider round"></span>
        </label>
      </section>
      <div class="thresholds_container" *ngIf="form.contextualSimilarity.value">
        <h4>{{ 'new_entries.contextual_similarity_threshold' | translate }}</h4>
        <app-small-info [title]="'new_entries.threshold_defines_the_percentage_at_which_a_sentence' | translate"
          [description]="'new_entries.by_default_the_contextual_similarity_threshold_is_80' | translate">
        </app-small-info>
        <app-custom-slider [handles]="translationHandles" [defaultValues]="translationDefaultValues"
          [rangeColors]="translationRangeColors" [showPercentageMarkers]="true" [showHandleValues]="true"
          [handleColors]="['#bcbcbc', '#F2A202']" [trackHeight]="'25px'" [handleHeight]="'50px'" [handleWidth]="'8px'"
          (handleChange)="onTranslationHandleChange($event)">
        </app-custom-slider>
      </div>
    </section>

    <!-- Threshold Configuration -->
    <section class="single_form_input">
      <section class="header">
        <h3>
          {{ 'new_entries.enable_thresholds' | translate }}
          <button matTooltipClass="new_report_tooltip" matTooltipPosition="above"
            [matTooltip]="'new_entries.thresholds_define_te_percentage_at_which_flagged_sentences' | translate">
            <img src="../../../../assets/report_v2/info.svg" alt="">
          </button>
        </h3>
        <label class="switch">
          <input type="checkbox" formControlName="enableThresholds" />
          <span class="slider round"></span>
        </label>
      </section>
      <div class="thresholds_container" *ngIf="this.form.enableThresholds.value">
        <!-- Similarity Thresholds -->
        <div class="thresholds_title">
          <button
            (click)="openLink('https://support.inspera.com/hc/en-us/articles/23841404707869-Inspera-Originality-Thresholds')">{{'new_entries.learn_more'
            | translate}}</button>
        </div>
        <!-- <section class="threshold-section"> -->
        <h4>{{'new_entries.exact_match_and_altered_text' | translate}}</h4>
        <app-small-info [title]="'new_entries.thresholds_define_the_percentage_at_which_a_sentence' | translate"
          [description]="'new_entries.the_default_threshold_for_possibly_altered_text_is_60_80' | translate">
        </app-small-info>
        <app-custom-slider [handles]="similarityHandles" [defaultValues]="similarityDefaultValues"
          [rangeColors]="similarityRangeColors" [showPercentageMarkers]="true" [showHandleValues]="true"
          [handleColors]="['#2994FF', '#ED457D']" [trackHeight]="'25px'" [handleHeight]="'50px'" [handleWidth]="'8px'"
          (handleChange)="onSimilarityHandleChange($event)">
        </app-custom-slider>
        <!-- </section> -->

        <!-- Contextual Similarity Threshold - only show if contextualSimilarity is enabled -->
        <!-- <section class="threshold-section" *ngIf="form.contextualSimilarity.value"> -->
        <!-- </section> -->
      </div>
    </section>

    <!-- Originality Feature Configuration -->
    <h2>{{ 'new_entries.display_interface_settings' | translate }}</h2>
    <p class="sub_heading">{{ 'new_entries.control_how_originality_scores_and_risk_levels_are_presented' | translate }}
    </p>

    <section class="single_form_input">
      <section class="header">
        <h3>
          {{'new_entries.show_originality_scores_in_the_originality_report_as' | translate}}
          <button matTooltipClass="new_report_tooltip" matTooltipPosition="above"
            [matTooltip]="'new_entries.show_originality_scores_in_the_originality_report_as_tooltip' | translate">
            <img src="../../../../assets/report_v2/info.svg" alt="">
          </button>
        </h3>
        <div class="custom-select-wrapper">
          <div class="custom-select-display" (click)="toggleDropdown()">
            <img [src]="getIconPath(this.form.originalityReportScoreDisplay.value || this.selectedOption)" alt="icon"
              class="icon" />
            <span>{{ getLabel(this.form.originalityReportScoreDisplay.value || this.selectedOption) }}</span>
            <img src="assets/images/icons/dropdown-arrow-up.png" alt="arrow" class="arrow" />
          </div>

          <!-- Dropdown (hidden by default) -->
          <div class="custom-select-options" *ngIf="dropdownOpen">
            <div class="option" *ngFor="let opt of options" (click)="selectOption(opt.value)">
              <img [src]="getIconPath(opt.value)" />
              <span>{{ opt.label }}</span>
            </div>
          </div>
        </div>
      </section>
    </section>

    <section class="single_form_input">
      <section class="header">
        <h3>
          {{'new_entries.show_originality_scores_in_the_user_interface_as' | translate}}
          <button matTooltipClass="new_report_tooltip" matTooltipPosition="above"
            [matTooltip]="'new_entries.show_originality_scores_in_the_user_interface_as_tooltip' | translate">
            <img src="../../../../assets/report_v2/info.svg" alt="">
          </button>
        </h3>
        <div class="custom-select-wrapper">
          <div class="custom-select-display" (click)="toggleUIDropdown()">
            <img [src]="getUIIconPath(this.form.userInterfaceScoreDisplay.value || this.uiSelectedOption)" alt="icon"
              class="icon" />
            <span>{{ getUILabel(this.form.userInterfaceScoreDisplay.value || this.uiSelectedOption) }}</span>
            <img src="assets/images/icons/dropdown-arrow-up.png" alt="arrow" class="arrow" />
          </div>

          <!-- Dropdown (hidden by default) -->
          <div class="custom-select-options" *ngIf="UIDropdown">
            <div class="option" *ngFor="let opt of UIoptions" (click)="selectUIOption(opt.value)">
              <img [src]="getUIIconPath(opt.value)" />
              <span>{{ opt.label }}</span>
            </div>
          </div>
        </div>
      </section>
    </section>

    <section class="single_form_input">
      <section class="header">
        <h3>
          {{'new_entries.configure_risk_classification_based_on_document_originality_score' | translate}}
          <button matTooltipClass="new_report_tooltip" matTooltipPosition="above"
            [matTooltip]="'new_entries.configure_risk_classification_based_on_document_originality_score' | translate">
            <img src="../../../../assets/report_v2/info.svg" alt="">
          </button>
        </h3>
        <!-- <label class="switch">
          <input type="checkbox" formControlName="enableRiskClassification" />
          <span class="slider round"></span>
        </label> -->
      </section>
      <div class="" *ngIf="this.form.enableRiskClassification.value">
        <custom-table [riskLevels]="defaultRiskLevels" (riskLevelsChange)="onRiskLevelsChange($event)">
        </custom-table>

        <!-- Contextual Similarity Threshold - only show if contextualSimilarity is enabled -->
        <!-- <section class="threshold-section" *ngIf="form.contextualSimilarity.value"> -->
        <!-- </section> -->
      </div>
    </section>

    <!-- Access and Permissions Settings -->
    <h2>{{'new_entries.access_and_permissions_settings' | translate}}</h2>
    <p class="sub_heading">{{'new_entries.these_settings_control_the_system_wide_availability' | translate}}
    </p>

    <!-- Educator User Management Permissions -->
    <section class="single_form_input">
      <section class="header">
        <h3>
          {{'new_entries.educator_user_management_permissions' | translate}}
          <button matTooltipClass="new_report_tooltip" matTooltipPosition="above"
            [matTooltip]="'new_entries.enable_or_disable_educators_ability_to_add_students' | translate">
            <img src="../../../../assets/report_v2/info.svg" alt="">
          </button>
        </h3>
        <label class="switch">
          <input type="checkbox" formControlName="canRegisterStudents" />
          <span class="slider round"></span>
        </label>
      </section>
    </section>

    <!-- Submission Pre Check -->
    <section class="single_form_input" *ngIf="institutionSettings?.submissionPrecheckPaid">
      <section class="header">
        <h3>
          {{ 'new_entries.submission_pre_check' | translate }}
          <button matTooltipClass="new_report_tooltip" matTooltipPosition="above"
            [matTooltip]="'new_entries.allow_pre_checks' | translate">
            <img src="../../../../assets/report_v2/info.svg" alt="">
          </button>
        </h3>
        <label class="switch">
          <input type="checkbox" formControlName="submissionPreCheck" />
          <span class="slider round"></span>
        </label>
      </section>
    </section>

    <!-- Add Document to Archive -->
    <section class="single_form_input">
      <section class="header">
        <h3>
          {{ 'new_entries.archive_documents' | translate }}
          <button matTooltipClass="new_report_tooltip" matTooltipPosition="above"
            [matTooltip]="'new_entries.archive_assignments' | translate">
            <img src="../../../../assets/report_v2/info.svg" alt="">
          </button>
        </h3>
        <label class="switch">
          <input type="checkbox" formControlName="archive" />
          <span class="slider round"></span>
        </label>
      </section>
    </section>

    <!-- Content Access -->
    <section class="single_form_input">
      <section class="header">
        <h3>
          {{ 'new_entries.content_access' | translate }}
          <button matTooltipClass="new_report_tooltip" matTooltipPosition="above"
            [matTooltip]="'new_entries.access_content_tooltip' | translate">
            <img src="../../../../assets/report_v2/info.svg" alt="">
          </button>
        </h3>
        <label class="switch">
          <input type="checkbox" [(ngModel)]="contentAccessEnabled" [ngModelOptions]="{standalone: true}"
            (change)="toggleContentAccess()" />
          <span class="slider round"></span>
        </label>
      </section>

      <!-- Content Access Info -->
      <section *ngIf="contentAccessEnabled" class="info">
        <img src="../../../assets/report_v2/info-blue.svg" alt="">
        <p>{{'new_entries.content_access_controls_external_access' | translate}} <a
            href="https://support.inspera.com/hc/en-us/articles/21237980575005-Access-Content-Feature"
            target="_blank">{{'new_entries.learn_more' | translate}}</a></p>
      </section>

      <!-- Institutions Access Table -->
      <section *ngIf="contentAccessEnabled" class="institutions-access-table">
        <div class="table-header">
          <div class="header-cell">
            <input type="checkbox" class="institution-checkbox" [checked]="areAllInstitutionsSelected()"
              [indeterminate]="areSomeInstitutionsSelected()"
              (change)="$event.target.checked ? selectAllInstitutions() : deselectAllInstitutions()">
            <span>{{'new_entries.client_name' | translate}}</span>
          </div>
          <div class="header-cell">{{'new_entries.access' | translate}}</div>
          <div class="header-cell"></div>
        </div>

        <div class="table-body">
          <div *ngFor="let institution of getDisplayedInstitutions(); let i = index" class="institution-row">
            <!-- Main Institution Row -->
            <div class="main-institution" [class.has-children]="institution.hasChildren"
              (click)="institution.hasChildren ? toggleInstitutionExpansion(institution.id) : null">
              <div class="institution-info">
                <input type="checkbox" class="institution-checkbox" [checked]="isParentChecked(institution)"
                  [indeterminate]="isParentIndeterminate(institution)"
                  (change)="toggleInstitutionSelection(institution.id, $event)" (click)="$event.stopPropagation()">
                <span class="institution-name">{{ institution.name }} {{ institution.hasChildren ? '(' +
                  institution.children.length + ' Institutions)' : '' }}</span>
              </div>
              <div class="access-control">
                <!-- Single access level -->
                <span *ngIf="!isMixedAccessLevel(determineParentAccessLevel(institution))" class="access-chip"
                  [ngClass]="{
                        'open-access': determineParentAccessLevel(institution) === 'open',
                        'closed-access': determineParentAccessLevel(institution) === 'closed',
                        'restricted-access': determineParentAccessLevel(institution) === 'restricted'
                      }">
                  {{ getAccessLevelLabel(determineParentAccessLevel(institution)) }}
                </span>

                <!-- Multiple access levels -->
                <div *ngIf="isMixedAccessLevel(determineParentAccessLevel(institution))" class="access-chips-container">
                  <span *ngFor="let accessLevel of determineParentAccessLevel(institution)" class="access-chip"
                    [ngClass]="{
                          'open-access': accessLevel === 'open',
                          'closed-access': accessLevel === 'closed',
                          'restricted-access': accessLevel === 'restricted'
                        }">
                    {{ getAccessLabelWithCount(accessLevel, getAccessLevelCounts(institution)[accessLevel], institution)
                    }}
                  </span>
                </div>
              </div>
              <div class="expand-icon" *ngIf="institution.hasChildren">
                <img
                  [src]="institution.isExpanded ? 'assets/images/icons/dropdown-arrow-up.png' : 'assets/images/icons/dropdown-arrow-down.png'"
                  alt="expand/collapse">
              </div>
            </div>

            <!-- Sub-institutions -->
            <div *ngIf="institution.hasChildren && institution.isExpanded" class="sub-institutions">
              <div *ngFor="let child of institution.children" class="sub-institution">
                <div class="institution-info">
                  <input type="checkbox" class="institution-checkbox" [checked]="selectedInstitutions.has(child.id)"
                    (change)="toggleSubInstitutionSelection(institution.id, child.id, $event)">
                  <span class="institution-name">{{ child.name }}</span>
                </div>
                <div class="access-control">
                  <div class="access-chips-container">
                    <span class="access-chip" [ngClass]="{
                            'open-access': child.accessLevel === 'open',
                            'closed-access': child.accessLevel === 'closed',
                            'restricted-access': child.accessLevel === 'restricted'
                          }">
                      {{ getAccessLevelLabel(child.accessLevel) }}
                    </span>
                  </div>
                </div>
                <div class="expand-icon"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Pagination Controls -->
        <div *ngIf="institutionsList && institutionsList.length > 0" class="pagination-container" role="navigation"
          aria-label="Institutions pagination controls">
          <div class="items-per-page">
            <label for="institutions-page-size-select">{{'new_entries.show' | translate}}:</label>
            <select id="institutions-page-size-select" [(ngModel)]="pageSize" [ngModelOptions]="{standalone: true}"
              (ngModelChange)="onInstitutionsPageSizeChange()" aria-label="Select number of institutions per page">
              <option value="5">5 {{'new_entries.items' | translate}}</option>
              <option value="10" *ngIf="totalInstitutions >= 10">10 {{'new_entries.items' | translate}}</option>
              <option value="25" *ngIf="totalInstitutions >= 25">25 {{'new_entries.items' | translate}}</option>
              <option value="50" *ngIf="totalInstitutions >= 50">50 {{'new_entries.items' | translate}}</option>
            </select>
          </div>

          <div class="page-indicator" role="status" aria-live="polite">
            {{ totalInstitutions > 0 ? ((page - 1) * +pageSize) + 1 : 0 }} - {{
            (page * +pageSize) > totalInstitutions
            ? totalInstitutions
            : (page * +pageSize)
            }} of {{ totalInstitutions }}
          </div>

          <div class="pagination-controls">
            <button class="pagination-arrow prev" [disabled]="page === 1" (click)="changeInstitutionsPage(page - 1)"
              aria-label="Previous page" tabindex="0">
              <span class="arrow" aria-hidden="true">&#10094;</span>
            </button>
            <button class="pagination-arrow next" [disabled]="page * +pageSize >= totalInstitutions"
              (click)="changeInstitutionsPage(page + 1)" aria-label="Next page" tabindex="0">
              <span class="arrow" aria-hidden="true">&#10095;</span>
            </button>
          </div>
        </div>

        <!-- Bulk Access Control -->
        <div class="bulk-access-control">
          <div class="set-access-section">
            <span>{{'new_entries.set_access' | translate}}:</span>
            <select [(ngModel)]="bulkAccessLevel" [ngModelOptions]="{standalone: true}" class="access-dropdown">
              <option value="open">{{'new_entries.open_access' | translate}}</option>
              <option value="closed">{{'new_entries.closed_access' | translate}}</option>
              <option value="restricted">{{'new_entries.restricted_access' | translate}}</option>
            </select>
            <button class="btn-blue-filled-xss" [disabled]="!canSaveAccessChanges()" (click)="applyBulkAccessLevel()">
              {{'new_entries.save_changes' | translate}}
            </button>
          </div>
        </div>
      </section>
    </section>

    <!-- Personal Identifiable Information -->
    <section class="single_form_input">
      <section class="header">
        <h3>
          {{ 'new_entries.personal_identifiable_information' | translate }}
          <button matTooltipClass="new_report_tooltip" matTooltipPosition="above"
            [matTooltip]="'pii_entities.tooltip' | translate">
            <img src="../../../../assets/report_v2/info.svg" alt="">
          </button>
        </h3>
        <label class="switch">
          <input type="checkbox" formControlName="personalIdentifiableInformation" />
          <span class="slider round"></span>
        </label>
      </section>
      <section class="chips" *ngIf="admin_settings.controls.personalIdentifiableInformation.value">
        <section>
          <mat-chip-list #chipList>
            <mat-chip *ngFor="let chip of admin_settings.controls.personalIdentifiableInformationInfo.value"
              [selectable]="true" [removable]="true" (removed)="removeChip(chip)">
              {{('pii_entities.' + chip.title.toLowerCase().replaceAll(' ', '_')) | translate}}
              <mat-icon matChipRemove>
                <img src="../../../assets/report_v2/blue-x-circle.svg" alt="">
              </mat-icon>
            </mat-chip>
          </mat-chip-list>
          <p class="zero_state"
            *ngIf="!admin_settings.controls.personalIdentifiableInformationInfo.value.length && !showChipInput">
            {{ 'pii_entities.zero_state' | translate }}
          </p>
        </section>
        <section class="btns_chips">
          <button *ngIf="!showChipInput" (click)="toggleChipInput()" #addMoreButton>+ {{'new_entries.add_more' |
            translate }}</button>
          <input *ngIf="showChipInput" [matAutocomplete]="auto" #chipInput (focus)="openAutocomplete()"
            [matAutocompleteDisabled]="!showChipInput" matAutocompletePosition="below"
            [placeholder]="'new_entries.add_more' | translate" style="padding-inline: 10px;"
            (keydown)="preventInput($event)">
          <mat-autocomplete #auto="matAutocomplete"
            (optionSelected)="addChipFromAutocomplete($event); $event.option.deselect()">
            <mat-option *ngFor="let option of allChipOptions" [value]="option">
              {{('pii_entities.' + option.title.toLowerCase().replaceAll(' ', '_')) | translate}}
            </mat-option>
          </mat-autocomplete>
        </section>
      </section>
    </section>

    <section class="form_btns">
      <button class="cancel_btn" (click)="cancel()" [disabled]="!isFormChanged"
        [ngClass]="{'disabled': !isFormChanged}">{{ 'general.reset' | translate }}</button>
      <button class="submit_btn" (click)="submitSettings()" [disabled]="!isFormChanged"
        [ngClass]="{'disabled': !isFormChanged}">{{ 'general.submit' | translate }}</button>

    </section>

  </form>
</section>